const { replace } = require('lodash');

class DynamicSuburbDialogContentController {
    constructor(fulfilmentService, settings, shopperService, moveFocus, gtm) {
        this.fulfilmentService = fulfilmentService;
        this.gtm = gtm;

        this.description = replace(settings.deliveryWindows.dynamicSuburbMessageDescription, '{Name}', (shopperService.IsGuest ? '' : shopperService.FirstName));
    }

    $onInit() {
        this.dialogCtrl.show();
    }

    onTimeSelect() {
        this.fireGtmEventAndCloseDialog('dynamic suburbs popup acknowledged - window selected');
    }

    onDecideLater() {
        this.fireGtmEventAndCloseDialog('dynamic suburbs popup ignored - no window selected');
    }

    fireGtmEventAndCloseDialog(eventFired) {
        this.gtm.push({ event: eventFired });
        this.closeDialog();
    }

    closeDialog() {
        this.dialogCtrl.close();
    }
}

module.exports = {
    template: require('./dynamicsuburb-dialog-content.component.html').trim(),
    require: { dialogCtrl: '^dialog' },
    controller: ['FulfilmentService', 'Settings', 'ShopperService', 'MoveFocus', 'GtmService', DynamicSuburbDialogContentController],
};



// WEBPACK FOOTER //
// ./src/shop/dynamicsuburb/dynamicsuburb-dialog-content.component.js